const ChutierIntegrated = ({language , token}) => {
    const newChutierIframe = "https:" +
    window.process.env.URL_Chutier
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_chutier_display"
        src={newChutierIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default ChutierIntegrated